import { Component, OnInit } from '@angular/core';
import {MenuController, ModalController} from "@ionic/angular";
import {ChooseDoctorListModalComponent} from "../choose-doctor-list-modal/choose-doctor-list-modal.component";
import {NotificationDetailComponent} from "../notification-detail/notification-detail.component";

@Component({
  selector: 'app-notification-panel',
  templateUrl: './notification-panel.component.html',
  styleUrls: ['./notification-panel.component.scss'],
})
export class NotificationPanelComponent implements OnInit {

  constructor(private modalController: ModalController,private menu: MenuController) { }

  ngOnInit() {}
  openNotificationDetail(){
    this.modalController.create({component:NotificationDetailComponent,id:"NotificationDetailModal" }).then((modalElement)=>
        {
          modalElement.present();
        }
    )
  }
  dismiss(){
    this.modalController.dismiss();
  }
  ionViewWillEnter() {
    this.menu.enable(false);
  }
  ionViewWillLeave() {
    this.menu.enable(true);
  }
}
